// Portal API client utility
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8147/api';

class ApiClient {
  constructor(baseURL = API_BASE_URL) {
    this.baseURL = baseURL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    // Add auth token if available
    const token = localStorage.getItem('spacejet-user-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        const requestError = new Error(data.message || `HTTP error! status: ${response.status}`);
        requestError.code = data.code;
        requestError.status = response.status;
        throw requestError;
      }

      return data;
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Convenience methods
  async get(endpoint, options = {}) {
    return this.request(endpoint, { method: 'GET', ...options });
  }

  async post(endpoint, data, options = {}) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
      ...options,
    });
  }

  async put(endpoint, data, options = {}) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
      ...options,
    });
  }

  async delete(endpoint, options = {}) {
    return this.request(endpoint, { method: 'DELETE', ...options });
  }
}

// Create and export a default instance
const api = new ApiClient();

// Specific API methods
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  clientSignup: (userData) => api.post('/auth/client-signup', userData),
  verify: (token) => api.post('/auth/verify', { token }),
};

export const contactsAPI = {
  submit: (contactData) => api.post('/contacts', contactData),
};

export const overlapAPI = {
  categories: () => api.get('/users/overlap/categories'),
};

export const trackingTesterAPI = {
  run: (payload) => api.post('/tracking-tester/run', payload)
};

export default api;
